export default "__VITE_ASSET__C5xZe$Xy__"